import {combine, forward, merge, sample} from 'effector';
import {saveAs} from 'file-saver';

import {RestError, showRestError} from 'core/errors';

import {
    commonData$,
    currentGtin$,
    currentGtinChanged,
    error$,
    fetchDataFx,
    fetchLabelsEvent,
    fetchLabelsFx,
    fetchPDFLabelsFx,
    fetchProductsFx,
    Gate,
    productsData$,
} from './index';

commonData$.on(fetchDataFx.done, (state, {result}) => result).reset(Gate.close);
productsData$.on(fetchProductsFx.done, (state, {result}) => result).reset(Gate.close);
error$
    .on(fetchDataFx.fail, (_, {error}: {error: Error}) => error as RestError)
    .reset(fetchDataFx, fetchDataFx.done, Gate.open, Gate.close);
currentGtin$.on(currentGtinChanged, (_, payload) => payload);

sample({
    clock: [Gate.open, fetchLabelsFx.done, fetchPDFLabelsFx.done],
    source: Gate.state,
    fn: (state) => state.id,
    target: fetchDataFx,
});

sample({
    clock: merge([Gate.open, fetchLabelsFx.done, fetchPDFLabelsFx.done]),
    source: combine({
        state: Gate.state,
    }),
    fn: ({state}) => ({
        orderId: state.id,
        paging: {
            pageNumber: 0,
            pageSize: 1000,
        },
        filters: [],
        sortings: [],
    }),
    target: fetchProductsFx,
});

forward({
    from: fetchLabelsEvent,
    to: fetchPDFLabelsFx,
});

fetchPDFLabelsFx.done.watch((response) => {
    const {params} = response;
    saveAs(response?.result.data?.data, `marking_codes_${params.orderId}_${params.gtin}.pdf`);
});

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));
fetchPDFLabelsFx.fail.watch(({error}) => showRestError(error as RestError));

fetchPDFLabelsFx.done.watch(() => {
    currentGtinChanged(null);
});
